import { PACKET_PRICE_ENUM } from "enums/PacketsEnum";
import { CustomerDiscount } from "types/CustomerTypes";

export const getDiscountedPrice = (
  plan: string | undefined,
  discounts?: CustomerDiscount[]
): number => {
  if (!plan) return 0;

  const basePrice: number =
    PACKET_PRICE_ENUM[
      plan.toLocaleUpperCase() as keyof typeof PACKET_PRICE_ENUM
    ] || 0;

  const discount = discounts?.find((d) =>
    d.applicableProducts?.includes(plan.toLowerCase())
  );

  if (!discount) return basePrice;

  if (discount.type === "fixed_amount") {
    return Math.max(0, basePrice - discount.amount);
  } else if (discount.type === "percentage") {
    return Math.max(0, basePrice - (basePrice * discount.amount) / 100);
  }

  return basePrice;
};
